document.addEventListener("DOMContentLoaded", () => {
  console.log("🚀 Iniciando Product Videos - solo MP4 (sin Instagram)");

  // ---------- Normalizar Dropbox ----------
  const normalizeDropboxUrl = (url) => {
    if (!url) return "";
    if (url.includes("dropbox.com")) {
      return url
        .replace("www.dropbox.com", "dl.dropboxusercontent.com")
        .replace("?dl=0", "");
    }
    return url;
  };

  // ---------- Cargar Swiper si no existe ----------
  const ensureScript = (src, cb) => {
    if (document.querySelector(`script[src="${src}"]`)) return cb && cb();
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => cb && cb();
    document.body.appendChild(s);
  };

  // ---------- Inicializar componente ----------
  const initProductVideos = () => {
    const section = document.querySelector(".product-videos-section");
    if (!section) return;

    // Normaliza URLs Dropbox
    section.querySelectorAll(".video-thumbnail video").forEach((video) => {
      const src = video.getAttribute("src");
      const fixed = normalizeDropboxUrl(src);
      if (fixed !== src) video.setAttribute("src", fixed);
    });

    const swiperEl = section.querySelector(".swiper");
    const videos = Array.from(section.querySelectorAll(".video-thumbnail video"));

    // ---- Inicializa Swiper ----
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      observer: true,
      observeParents: true,
      grabCursor: true,
      autoHeight: false,
      navigation: {
        nextEl: section.querySelector(".swiper-button-next"),
        prevEl: section.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: section.querySelector(".swiper-pagination"),
        clickable: true,
      },
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 24 },
        1024: { slidesPerView: 2, spaceBetween: 24 },
      },
      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,
      threshold: 6,
      on: {
        init() {
          console.log("✅ Swiper inicializado correctamente");
          handleSlideChange(this);
        },
        transitionEnd() {
          handleSlideChange(this);
        },
      },
    });

    // ---- Configurar videos ----
    videos.forEach((video) => {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = "metadata";
    });

    // ---- Click/tap en TODO el slide ----
    section.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.addEventListener("click", (e) => handleTap(slide, e));
      slide.addEventListener("touchend", (e) => handleTap(slide, e));
    });

    // ---- Función de click/tap ----
    function handleTap(slide, e) {
      e.preventDefault();
      e.stopPropagation();

      const video = slide.querySelector("video");
      if (!video) return;

      // Alternar play/pause
      if (video.paused) {
        // Solo un video con sonido en mobile
        if (window.innerWidth < 768) {
          videos.forEach((v) => {
            if (v !== video) {
              v.pause();
              v.currentTime = 0;
              v.muted = true;
            }
          });
        }
        video.muted = false;
        video.play().catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    }

    // ---- Control de sonido solo en mobile ----
    function handleSlideChange(sw) {
      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        videos.forEach((v) => {
          v.pause();
          v.muted = true;
          v.currentTime = 0;
        });

        const activeSlides = sw.slides.filter((s) =>
          s.classList.contains("swiper-slide-active")
        );
        activeSlides.forEach((slide) => {
          const v = slide.querySelector("video");
          if (v) {
            v.muted = false;
            v.play().catch(() => {});
          }
        });
      }
    }
  };

  // ---- Cargar Swiper y luego iniciar ----
  ensureScript("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js", initProductVideos);
});
